import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { useInView } from '../hooks/useInView';
interface ProtocoloSectionProps {
  handlePurchase: () => void;
}
export function ProtocoloSection({
  handlePurchase
}: ProtocoloSectionProps) {
  const includes = ['Abundance Master Manual (High-Res PDF)', '888Hz Frequency Audio (High-Fidelity MP3)', '21-Day Activation Guide', 'Nighttime Reprogramming Protocol', 'Immediate and Lifetime Access', '2026 Updates Included'];
  const [leftRef, leftInView] = useInView();
  const [rightRef, rightInView] = useInView();
  return <section id="protocolo" aria-label="The complete protocol - content and price" className="py-16 sm:py-24 px-4 sm:px-[5%] bg-[#0f0f11] relative border-t border-white/5" data-id="element-139">
      <div className="max-w-[1000px] mx-auto" data-id="element-140">
        <div className="bg-dark border border-gold/30 rounded-2xl p-6 sm:p-8 md:p-12 shadow-[0_0_50px_rgba(212,175,55,0.1)]" data-id="element-141">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-142">
            <div ref={leftRef} className={`will-animate animate-slideLeft ${leftInView ? 'is-visible' : ''}`} data-id="element-143">
              <h2 className="font-serif text-3xl md:text-4xl font-black mb-6" data-id="element-144">
                THE COMPLETE <br data-id="element-145" />
                <span className="text-gold" data-id="element-146">PROTOCOL</span>
              </h2>
              <p className="text-white/85 mb-8" data-id="element-147">
                Everything you need to start your neuro-quantum reprogramming
                today.
              </p>
              <ul className="space-y-4 mb-8" role="list" data-id="element-148">
                {includes.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-149">
                    <CheckCircle2Icon className="w-6 h-6 text-gold shrink-0" aria-hidden="true" data-id="element-150" />
                    <span className="text-white/95" data-id="element-151">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div ref={rightRef} className={`text-center bg-white/5 p-8 rounded-xl border border-white/10 will-animate animate-slideRight ${rightInView ? 'is-visible' : ''}`} data-id="element-152">
              <div className="mb-6" data-id="element-153">
                <span className="text-5xl font-black text-gold" aria-label="Price 6 dollars and 39 cents" data-id="element-154">
                  $6.39
                </span>
              </div>
              <p className="text-sm text-white/75 mb-8" data-id="element-155">
                One-time payment. No hidden subscriptions.
              </p>

              <button onClick={handlePurchase} className="bg-gold text-dark border-none py-4 px-6 text-base font-black rounded cursor-pointer transition-all duration-300 shadow-[0_10px_25px_rgba(212,175,55,0.3)] w-full hover:scale-[1.03] hover:bg-[#f1c40f]" data-id="element-156">
                DOWNLOAD $6.39
              </button>

              <div className="mt-6 flex items-center justify-center gap-2 text-white/65 text-xs" data-id="element-157">
                <span aria-label="100% Secure and Encrypted Purchase" data-id="element-158">
                  🔒 100% Secure and Encrypted Purchase
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}